/*
 * Club-join gift prompt - behaviour only.
 *
 * Markup: snippets/club-join-popup.liquid, styles: assets/custom.css.
 * Ported from the Variant experience EXPE9BEC753, variation 1.
 *
 * All that cannot be rendered ahead of time is here: the trigger (the cart
 * reaching three items, or sixty seconds into the visit, whichever comes
 * first), the once-per-session guard, and the handoff to the store's own club
 * panel. The original also carried four nested setTimeouts to step
 * the gift through pop, roll and fade-out, plus a fifth that tore the overlay
 * down if one of them never ran. The steps are one CSS animation list now, so
 * the only timer left in the sequence is the one that waits for it to end -
 * and it also covers the reduced-motion case, where no animation runs at all.
 */
(function () {
  'use strict';

  var EXPERIMENT_ID = 'EXPE9BEC753';
  var VARIATION_ID = '1';
  var SESSION_KEY = 'variant_club_popup_EXPE9BEC753';
  var START_KEY = SESSION_KEY + '_start';

  // Fallback for visitors who never get to three items.
  var DELAY_MS = 60000;
  // The cart item count (quantities included) that triggers the prompt.
  var CART_THRESHOLD = 3;
  // Lets the cart drawer's own opening finish before the gift dims the page.
  var AFTER_ADD_MS = 1200;
  // Pop (0.45s) + roll and spin (1.5s, starting at 0.48s) + fade-out (0.35s,
  // starting at 1.98s), with a frame to spare. Keep in sync with the
  // animation list in assets/custom.css.
  var SEQUENCE_MS = 2350;
  // Matches the veil's opacity transition.
  var VEIL_MS = 700;

  var popup = document.querySelector('[data-club-join-popup]');
  if (!popup) return;

  var veil = document.querySelector('[data-club-join-veil]');

  // Storage is unavailable in some privacy modes, where reading it throws.
  // Treat that as "not shown yet": the prompt then behaves as it does on a
  // first visit rather than never appearing at all.
  function alreadyShown() {
    try {
      return sessionStorage.getItem(SESSION_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function remember() {
    try {
      sessionStorage.setItem(SESSION_KEY, '1');
    } catch (e) {
      /* nothing to do - the prompt may show again in this session */
    }
  }

  function track(eventName, extra) {
    try {
      if (typeof Variant === 'undefined' || !Variant.publishCustomEvent) return;
      var payload = { experiment_id: EXPERIMENT_ID, variation_id: VARIATION_ID };
      for (var key in extra) {
        if (Object.prototype.hasOwnProperty.call(extra, key)) payload[key] = extra[key];
      }
      Variant.publishCustomEvent(eventName, payload);
    } catch (e) {
      /* never break the page for analytics */
    }
  }

  // The club panel belongs to the Valuecard widget. The floating stack's club
  // band is the theme's own way in (see assets/floating-unified-button.js), so
  // the click goes there first and to the widget's tab only if the stack is
  // not on the page - the same order the original used. With neither of them
  // present nothing opens, exactly as before.
  function openClubPanel() {
    track('influenced-revenue', { action: 'club_window_opened' });

    var clubButton = document.querySelector('[data-floating-stack-club]');
    if (clubButton) {
      clubButton.click();
      return;
    }

    var widget = document.querySelector('.vc-widget-left');
    if (widget) widget.click();
  }

  // A white veil that fades out as the club panel appears, so the panel reads
  // as a fade-in rather than a jump.
  function openClubPanelBehindVeil() {
    if (!veil) {
      openClubPanel();
      return;
    }

    veil.hidden = false;
    openClubPanel();

    nextFrame(function () {
      veil.classList.add('is-fading');
    });

    setTimeout(function () {
      veil.hidden = true;
      veil.classList.remove('is-fading');
    }, VEIL_MS);
  }

  // Two frames: the first lays the element out now that it is no longer
  // hidden, the second gives the transition a starting value to animate from.
  function nextFrame(callback) {
    requestAnimationFrame(function () {
      requestAnimationFrame(callback);
    });
  }

  function show() {
    if (alreadyShown()) return;
    remember();

    popup.hidden = false;
    nextFrame(function () {
      popup.classList.add('is-open');
    });

    setTimeout(function () {
      popup.hidden = true;
      popup.classList.remove('is-open');
      openClubPanelBehindVeil();
    }, SEQUENCE_MS);
  }

  if (alreadyShown()) return;

  // The sixty seconds run from the first page of the visit, not from each page
  // load, or a shopper who keeps browsing would restart the clock every time.
  function msUntilFallback() {
    var now = Date.now();
    var start = now;
    try {
      start = parseInt(sessionStorage.getItem(START_KEY), 10) || now;
      if (start === now) sessionStorage.setItem(START_KEY, String(now));
    } catch (e) {
      /* falls back to sixty seconds from this page load */
    }
    return Math.max(0, DELAY_MS - (now - start));
  }

  var fallbackTimer = setTimeout(show, msUntilFallback());
  var triggered = false;

  function showAfterAdd() {
    if (triggered) return;
    triggered = true;
    clearTimeout(fallbackTimer);
    setTimeout(show, AFTER_ADD_MS);
  }

  function checkCount(cart) {
    if (cart && cart.item_count >= CART_THRESHOLD) showAfterAdd();
  }

  // The product form announces its adds with the cart attached.
  document.documentElement.addEventListener('cart:change', function (event) {
    if (event.detail && event.detail.baseEvent === 'variant:add') checkCount(event.detail.cart);
  });

  // The bundle builder, bundle offer, complete-the-set and cart upsell post to
  // /cart/add.js themselves and do not all raise cart:change, so successful
  // adds are watched at the fetch level and the cart is read back afterwards.
  var nativeFetch = window.fetch;
  if (typeof nativeFetch !== 'function') return;

  window.fetch = function (input) {
    var promise = nativeFetch.apply(this, arguments);
    var url = input && typeof input === 'object' && 'url' in input ? input.url : input;
    if (!triggered && url && /\/cart\/add(\.js)?(\?|$)/.test(String(url))) {
      promise.then(function (response) {
        if (!response.ok || triggered) return;
        nativeFetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart.js')
          .then(function (r) { return r.json(); })
          .then(checkCount)
          .catch(function () {});
      }).catch(function () {});
    }
    return promise;
  };
})();
